module.exports = "/* dummy val to identify this style sheet in style section  */\n.se-element {\n  display: block;\n}\nimg {\n  width: 100%;\n  height: 100%;\n}\n.image-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.svg-container {\n  width: 100%;\n  height: 100%;\n}\n::ng-deep .svg-container svg {\n  width: 100%;\n  height: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-shape/se-shape.component.css
// module id = ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-shape/se-shape.component.css
// module chunks = main